// @ts-nocheck
import React from 'react';
import './SelectList.less';

export const SelectList = ({children}) => {
	return <ul className="select-list">
		{children}
	</ul>
}
